import React from 'react';
import * as styles from './CTA.module.styl';

export default function CTA(props) {
  return (
    <form className={styles.getStartedForm} action="/register" method="GET">
      <input
        type="email"
        name="email"
        autoFocus={props.autoFocus || false}
        placeholder={props.inputPlaceholder || 'Email Address'}
      />
      <button type="button">{props.btnText || 'Get Started'}</button>
      <small>{props.btnLabel || '7 Day Free Trial, No CC Required'}</small>
    </form>
  );
}
